module.exports = __webpack_public_path__ + "a380977fef4f371e94fd3cc63373bc91.png";